document.addEventListener("DOMContentLoaded", function () {
  const page = document.querySelector("[data-tournament-page]");
  if (!page) return;

  requestAnimationFrame(function () {
    page.dataset.ready = "true";
  });

  document.body.classList.add("tp-hide-main-header");
  document.body.classList.add("tp-hide-main-footer");

  const possibleHeadersAndFooters = [
    /* headers */
    ".tp-nav",
    "header.header",
    ".shopify-section-header",
    "#shopify-section-header",
    ".header-wrapper",
    ".site-header",
    "#shopify-section-sections--header",

    /* footers */
    "footer",
    ".footer",
    ".site-footer",
    ".shopify-section-footer",
    "#shopify-section-footer",
    ".footer-wrapper",
    "#shopify-section-sections--footer",
    ".tp-footer"
  ];

  possibleHeadersAndFooters.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (element) {
      if (!element.closest(".tp-premier-padel")) {
        element.style.display = "none";
      }
    });
  });

  const homeLinks = document.querySelectorAll(
    ".tp-premier-padel__brand, .tp-premier-padel__home-btn"
  );

  homeLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      window.location.href = "https://tacticalpadel.com/";
    });
  });
});